import { render, staticRenderFns } from "./QTotalRecruitsDrilldown.vue?vue&type=template&id=b5d185f8&scoped=true&"
import script from "./QTotalRecruitsDrilldown.vue?vue&type=script&lang=js&"
export * from "./QTotalRecruitsDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d185f8",
  null
  
)

export default component.exports